import _ from "lodash"; 
import { connect } from "react-redux";

import { fetchUserProfile } from "src/redux/actions/users";
import {fetchShareSection } from "src/legacy/redux/actions/conversationSection.jsx";
import { fetchAssetAnalytics } from "src/legacy/redux/actions/conversations";

import OpportunitySharesView from "./view";
import { fetchHubspotSharesForOpportunity } from "src/redux/actions/integrations/hubspot";

const mapStateToProps = (state, ownProps) => {

  const shares = _.get(state,"integrations.hubspot.sharesForOpportunity");
  const opportunityId = window.location.pathname.split('/')[4];

  return {
    id: opportunityId,
    location: window.location,
    currentPage: _.get(shares, "pagination.currentPage", 0),
    totalPages: _.get(shares, "pagination.totalPages", 0),
    shares: _.get(shares, "records", []),
    loadingShares: _.get(shares, "loading", false),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {

    fetchUserProfile: () => {
      dispatch(fetchUserProfile());
    },

    fetchData: (id, page) => {
      return dispatch(fetchHubspotSharesForOpportunity(id, page));
    },

    fetchShareSection: (shareId, sectionId) => {
      return dispatch(fetchShareSection(shareId, sectionId));
    },

    fetchAssetAnalytics: (shareID, sectionID, assetID) => {
      return dispatch(fetchAssetAnalytics(shareID, sectionID, assetID));
    },
  };
};

const HubspotOpportunitySharesContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(OpportunitySharesView);

export default HubspotOpportunitySharesContainer;